<div class="interiorWrap ">

    <div class="container">
        <div class="row">
            <div class="col-12">
                <h2 class="m-0 text-secondary">Latest News</h2>
            </div>
        </div>
    </div>

    <div class="heroSection" *ngIf="latestNews.articleId != null">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="card heroCard">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="heroInfo">
                                    <h3 class="heroTitle">{{latestNews.title}}</h3>
                                    <p class="heroMeta">{{latestNews.memberName}} | {{latestNews.dateString}}</p>
                                    <p class="heroBlurb" *ngIf="latestNews.contentShortened == null" [innerHTML]="latestNews.contentFull"></p>
                                    <p class="heroBlurb" *ngIf="latestNews.contentShortened != null" [innerHTML]="latestNews.contentShortened"></p>
                                    <a [routerLink]="['/public/member-news/article', latestNews.articleId]" class="btn btn-secondary heroBtn">Read More</a>
                                </div>
                            </div>
                            <div class="col-lg-6 d-none d-lg-block">
                                <div *ngIf="latestNews.imageUrl == ''" class="heroImgContainer" [routerLink]="['/public/member-news/article', latestNews.articleId]" style="background-image: url('../../assets/images/member_news_default.png');"></div>
                                <div *ngIf="latestNews.imageUrl != ''" class="heroImgContainer" style="background-position: center;" [routerLink]="['/public/member-news/article', latestNews.articleId]" style="background-image: url('{{latestNews.imageUrl}}');"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    

    <section class="page-container">

        <div class="container">

            <div class="row mb-4 pb-4">

                <div class="col-12 mb-3">
                    <div class="searchCta mb-3">
                        Browse Member News
                    </div>
                    <div class="mainSearch">
                        <div class="searchContainer">
                            <div class="searchBox m-100">
                                <input type="search" [(ngModel)]="searchText" class="form-control" placeholder="search our member news...">
                                <button type="button" (click)="searchNews(true)" class="btn btn-secondary m-100">Search News</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-4">
                    <label for="filterBy" class="form-label">Filter By:</label>
                    <!-- <input id="filter-input" class="mobi-input form-control form-select-lg" data-dropdown="true" placeholder="Filter News By" /> -->
                    <!-- https://indychamber.com/category/member-news/ -->
                    <select class="form-select form-select-lg mb-3" [(ngModel)]="memberSearch" aria-label="discounts from">
                        <option selected value="0">Anyone</option>
                        <option *ngFor="let company of membersWithNews" value="{{company.companyId}}">{{company.memberName}}</option>
                      </select>
                </div>

                <div class="col-md-4">
                    <label for="timeRange" class="form-label">Time</label>
                    <select class="form-select form-select-lg mb-3" [(ngModel)]="timeSearch" aria-label="time select">
                        <option value="0" selected>All Time</option>
                        <option value="1">Last 30 Days</option>
                        <option value="2">Last 90 Days</option>
                        <option value="3">Last 6 Months</option>
                      </select>
                </div>

            </div>



            <hr />

            <div class="newsListWrap mt-4 row row-cols-1 row-cols-xl-3 row-cols-lg-2 row-cols-md-1 row-cols-sm-1 g-4">

                <div class="col" *ngFor="let article of articles" >
                    <div class="articleCard card h-100">
                        <div *ngIf="article.imageUrl != ''"  [routerLink]="['/public/member-news/article', article.articleId]" class="articleImg" style="background-image: url('{{article.imageUrl}}');"></div>
                        <div  *ngIf="article.imageUrl == ''" [routerLink]="['/public/member-news/article', article.articleId]" class="articleImg" style="background-image: url('../../assets/images/member_news_default.png');background-position:center;"></div>
                        <div class="articleDate">
                            {{article.dateString}}
                        </div>
                        <a [routerLink]="['/public/member-news/article', article.articleId]" class="articleTitle">
                            {{article.title}}
                        </a>
                        <div class="articleBlurb">
                            <span *ngIf="article.contentShortened == null" [innerHTML]="article.contentFull"></span>
                            <span *ngIf="article.contentShortened != null" [innerHTML]="article.contentShortened"></span>
                        </div>
                    </div>
                </div>

                
                
            </div>

            <div class="row memberDirectory">
                <div class="col-12">
                    <div class="paginationWrap">
                        <nav aria-label="Indy Chamber member news pagination">
                            <ngb-pagination class="pagination paginationFloaty justify-content-center" [maxSize]="4" [ellipses]="true"
                                [collectionSize]="totalResults" [(page)]="currentPageNum" [pageSize]="itemsPerPage">
                            </ngb-pagination>

                            <!-- <ul class="pagination paginationFloaty justify-content-center">
                                <li *ngIf="page > 0" class="page-item">
                                    <a class="page-link" href="javascript:void(0)" aria-label="Previous" (click)="prevPage()">
                                        <span aria-hidden="true">« Previous</span>
                                    </a>
                                </li>
                                <li *ngFor="let item of [].constructor(totalPages); 
                                    let i = index" class="page-item" [ngClass]="{'active': page == i}">
                                    <a class="page-link" (click)="goToPage(i)"
                                        href="javascript:void(0)">{{i+1}}</a>
                                </li>
                                <li class="page-item" *ngIf="page < totalPages">
                                    <a class="page-link" href="javascript:void(0)" aria-label="Next" (click)="nextPage()">
                                        <span aria-hidden="true">Next »</span>
                                    </a>
                                </li>
                            </ul> -->
                        </nav>
                    </div>
                </div>
            </div>
        </div>

        

    </section>
</div>
